
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface SalesChartProps {
  data: {
    month: string;
    newSales: number;
    recurringSales: number;
    totalRevenue: number;
  }[];
  formatCurrency: (amount: number) => string;
}

const SalesChart: React.FC<SalesChartProps> = ({ data, formatCurrency }) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Monthly Revenue</CardTitle>
        <CardDescription>Reseller Pro monthly sales and revenue</CardDescription>
      </CardHeader>
      <CardContent className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" tickFormatter={(value) => `$${value / 1000}k`} />
            <Tooltip formatter={(value, name) => {
              if (name === 'totalRevenue') return [formatCurrency(Number(value)), 'Revenue'];
              return [value, name === 'newSales' ? 'New Sales' : 'Recurring Sales'];
            }} />
            <Legend />
            <Bar yAxisId="left" dataKey="newSales" name="New Sales" fill="#8884d8" />
            <Bar yAxisId="left" dataKey="recurringSales" name="Recurring Sales" fill="#82ca9d" />
            <Bar yAxisId="right" dataKey="totalRevenue" name="Revenue" fill="#ffc658" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default SalesChart;
